module.exports = __webpack_public_path__ + "media/public/images/about/experts/center_repin-8c484d1d714f320323cb22298243d918.svg";